import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PortfolioGanttViewComponent } from './portfolio-gantt-view.component';
import { I18nModule } from "app/shared/i18n/i18n.module";
import { MaterialModule } from 'app/material.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PortfolioGanttViewRoutingModule } from './portfolio-gantt-view-routing.module';
import { DxDataGridModule, DxSelectBoxModule, DxAutocompleteModule, DxTextBoxModule, DxListModule, DxTagBoxModule, DxDropDownBoxModule, DxTreeViewModule } from 'devextreme-angular';

@NgModule({
  imports: [
    CommonModule,
    DxDataGridModule,
    I18nModule,
    MaterialModule,
    FormsModule,
    NgxSpinnerModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxDropDownBoxModule,
    DxTreeViewModule,
    DxListModule,
    DxTagBoxModule,
    DxAutocompleteModule,
    PortfolioGanttViewRoutingModule
  ],
  declarations: [
    PortfolioGanttViewComponent
  ]
})
export class PortfolioGanttViewModule { }
